import { FaHome, FaClock, FaBook, FaMoneyBill, FaUserCog } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useState } from "react";


export default function BottomMenu({ role }) {
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData")) || "{}";
  const [activeTab, setActiveTab] = useState("dashboard");
  const handleNav = (tab, path, state = {}) => {
    setActiveTab(tab);
    navigate(path, { state });
  };


  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-200 border-t shadow-md flex justify-around items-center h-14 md:hidden">
      {/* Default options */}
      <button
         onClick={() => handleNav("dashboard", "/dashboard")}
        className={`flex flex-col items-center ${
          activeTab === "dashboard" ? "text-blue-600" : "text-gray-600"
        }`}

      >
        <FaHome size={20} />
        <span className="text-xs">Home</span>
      </button>

      <button
       onClick={() =>
          handleNav("mytime", "/dashboard/myTime", { staffData: userData })
        }
        className={`flex flex-col items-center ${
          activeTab === "mytime" ? "text-blue-600" : "text-gray-600"
        }`}
      >
        <FaClock size={20} />
        <span className="text-xs">Attendance</span>
      </button>

      <button
         onClick={() => handleNav("homework", "/dashboard/homework")}
        className={`flex flex-col items-center ${
          activeTab === "homework" ? "text-blue-600" : "text-gray-600"
        }`}

      >
        <FaBook size={20} />
        <span className="text-xs">Homework</span>
      </button>

      <button
        onClick={() => handleNav("fee", "/dashboard/fees")}
        className={`flex flex-col items-center ${
          activeTab === "fee" ? "text-blue-600" : "text-gray-600"
        }`}

      >
        <FaMoneyBill size={20} />
        <span className="text-xs">Fee</span>
      </button>

      {/* Role-based extra option */}
      {role === "ADMIN" && (
        <button
           onClick={() => handleNav("admin", "/dashboard/organisation")}
          className={`flex flex-col items-center ${
            activeTab === "admin" ? "text-blue-600" : "text-gray-600"
          }`}

        >
          <FaUserCog size={20} />
          <span className="text-xs">Admin</span>
        </button>
      )}
    </div>
  );
}